/** @format */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LocaleText } from "../features/i18n/init";

export interface AdminState {
  isMaintenance: boolean;
  message: LocaleText;
}

const initialState: AdminState = {
  isMaintenance: false,
  message: { en: "", cy: "" },
};

export const adminSlice = createSlice({
  name: "admin",
  initialState: initialState,
  reducers: {
    setMaintenance: (
      state,
      action: PayloadAction<{ isMaintenance: boolean; message: LocaleText }>,
    ) => {
      state.isMaintenance = action.payload.isMaintenance;
      state.message = action.payload.message;
    },
  },
});

export const { setMaintenance } = adminSlice.actions;
export default adminSlice.reducer;
